/**
 *
 * Asynchronously loads the component for Business Analytics
 *
 */

import Loadable from 'react-loadable'

export default Loadable({
  loader: () => import('./index' /* webpackChunkName: "BusinessAnalytics" */),
  loading: () => null
})
